export namespace SystemUserFormPageConstants {
  export const LoadSystemUser = 'LoadSystemUser';
  export const ProcessSystemUser = 'ProcessSystemUser';
  export const swedenId = 215;
  export const systemUsersFormId = 'systemUsersFormId';
}
